export const ths = [
    {
      id: 1,
      label: 'Date Uploaded',
      intlKey: 'table.date_uploaded'
    },
    {
      id: 1,
      label: 'Expires',
      intlKey: 'table.expires'
    },
    {
      id: 3,
      label: 'File Name',
      intlKey: 'table.filename'
    },
    {
      id: 4,
      label: 'Status',
      intlKey: 'table.status'
    },
    {
      id: 5,
      label: 'Award Centre',
      intlKey: 'table.award_centre'
    },
    {
      id: 6,
      label: 'Action',
      intlKey: 'table.action'
    },
  ]
